import { Button } from 'antd';
import Container from '../../components/Layout/Container';
import common from './Common.module.scss';
import local from './SectionMidBreak.module.scss';
import avatarImg from '../../assets/images/quick-kindness.svg';
import { useSurveyContext } from '../../context/SurveyContext';

const Section1MidBreak = () => {
  const { setCurrentStep, setCurrentSubsection } = useSurveyContext();

  const handleContinue = () => {
    // Continue from the next subsection after the mid-break
    setCurrentSubsection(6); // Continue from subsection 7 (index 6)
    setCurrentStep('section-1');
  };

  return (
    <div className={`${common.surveyWrapper} ${local.surveyWrapper}`}>
      <Container>
        <div className={common.surveyAvatarWrapper}>
          <img src={avatarImg} alt="Quick Kindness Avatar" className={common.surveyAvatar} />
        </div>
        <div className={common.surveyTextSection}>
          <h1 className={common.surveyTitle}>A quick kindness</h1>
          <div className={`${common.surveyParagraphs} ${local.centeredText}`}>
            <p>
              If you are constantly feeling like a fraud and have self-doubts, you're not alone—and it says nothing about your real ability. A 2025 meta-analysis pooling 30 studies and 11,483 people found about 62% experience impostor feelings at some point.
            </p>
            <p style={{ marginTop: 16, marginBottom: 16, fontSize: 14, color: '#666', fontStyle: 'italic' }}>
              Source: Salari et al., BMC Psychology (2025). PubMed
            </p>
            <p>
              When you're ready, tap Continue to keep going.
            </p>
          </div>
          <div className={common.surveyButtonWrapper}>
            <Button 
              type="primary" 
              className={common.surveyButton} 
              onClick={handleContinue}
              block
            >
              Continue
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Section1MidBreak;
